import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { ImpersonationService } from '../../services/impersonation.service';

@Component({
  standalone: true,
  selector: 'app-impersonation-banner',
  imports: [CommonModule, MatIconModule, MatButtonModule],
  template: `
    @if (impersonation.active) {
      <div class="impersonation-banner">
        <mat-icon>visibility</mat-icon>
        <span>Simulando sesión de <strong>{{ impersonation.email }}</strong></span>
        <button mat-stroked-button (click)="impersonation.stop()">
          <mat-icon>close</mat-icon> Salir
        </button>
      </div>
    }
  `,
  styles: [`
    .impersonation-banner {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 8px 20px;
      background: #e65100;
      color: #fff;
      font-size: 14px;
      position: sticky;
      top: 0;
      z-index: 1000;
    }
    mat-icon { font-size: 18px; height: 18px; width: 18px; }
    span { flex: 1; }
    button { color: #fff; border-color: rgba(255,255,255,0.6); }
  `]
})
export class ImpersonationBannerComponent {
  constructor(public impersonation: ImpersonationService) {}
}
